module.exports = __webpack_public_path__ + "static/media/screen1.a27536f3.png";